/**
 * User: nir
 * Date: 04/09/2016
 * Time: 18:56
 */

(function ($) {
    $(function () {
        var container = $('#mobile-genres'),
            item = $('li.active', container);

        if (container.length && item.length) {
            var y = container[0],
                x = item[0];

            container.animate({scrollLeft: x.offsetLeft + (x.clientWidth / 2) - (y.clientWidth / 2)}, 200);
        }
    })
})(window.jQuery);